<template>
  <v-list-item>
    <v-list-item-action>
      <v-checkbox v-model="layerAction" :disabled="layerStepsLoading"/>
    </v-list-item-action>
    <v-list-item-content>
      <v-list-item-title v-text="layerInfo.name"/>
      <v-list-item-subtitle v-text="layerInfo.subname"/>
      <v-progress-linear
          v-if="layerStepsLoading"
          indeterminate
          color="primary"
      ></v-progress-linear>
      <div v-else class="mt-2">
        <v-select
            :items="temporalResolutionItems"
            label="Zeitliche Auflösung"
            v-model="selectedTemporalResolution"
            item-text="name"
            item-value="key"
        ></v-select>
        <v-select
            class="px-2"
            label="Datum/Uhrzeit für angezeigten Layer"
            v-model="selectedLayerStep"
            :items="filteredLayerStepItems"
            :item-text="formatDateSelect"
            item-value="datetime"
            prepend-icon="mdi-chevron-left"
            @click:prepend="selectOlderLayerStep"
            @change="changeMapLayer"
        >
          <template v-slot:append-outer>
            <v-icon @click="selectNewerLayerStep">mdi-chevron-right</v-icon>
            <v-menu
                v-if="selectedTemporalResolution === 'daily'"
                v-model="showMenu"
                ref="menu"
                :close-on-content-click="false"
                :return-value.sync="selectedCalenderStep"
                transition="scale-transition"
                offset-y
                min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                    class="mr-3"
                    v-bind="attrs"
                    v-on="on"
                >mdi-calendar
                </v-icon>
              </template>
              <v-date-picker
                  elevation="15"
                  v-model="selectedCalenderStep"
                  no-title
                  scrollable
                  :max="maxCalendarDate"
                  :min="minCalendarDate"
                  :allowed-dates="allowedCalendarDates"
              >
                <v-spacer></v-spacer>
                <v-btn
                    text
                    color="primary"
                    @click="showMenu = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                    text
                    color="primary"
                    @click="saveCalendarDate"
                >
                  OK
                </v-btn>
              </v-date-picker>
            </v-menu>
          </template>
        </v-select>
        <v-divider/>
      </div>
    </v-list-item-content>
    <v-list-item-action v-if="layerInfo.infoText">
      <v-dialog
          v-model="dialog"
          scrollable
          width="500"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              icon
              v-bind="attrs"
              v-on="on">
            <v-icon color="grey lighten-1">mdi-information</v-icon>
          </v-btn>
        </template>
        <v-card>
          <v-card-title class="primary white--text">
            {{ layerInfo.name }}
          </v-card-title>
          <v-card-text class="pt-3" style="max-height: 500px" v-html="layerInfo.infoText">
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="primary"
                text
                @click="dialog = false"
            >
              ok
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import {mapActions, mapState} from "vuex";
import ApiService from "@/services/api.service.js"

export default {
  name: "layerEntryRastless",
  props: ["layerId"],
  data: () => ({
    dialog: false,
    layerStepsLoading: true,
    layerStepItems: [],
    selectedLayerStep: "",
    temporalResolutionItems: [{name: "Täglich", key: "daily"}, {name: "Monatlich", key: "monthly"}],
    selectedTemporalResolution: "daily",
    maxCalendarDate: "",
    minCalendarDate: "",
    showMenu: false
  }),
  computed: {
    layerAction: {
      get() {
        return this.layerInfo.active
      },
      set() {
        this.toggle_layer(this.layerId)
      }
    },
    ...mapState("map", ["layerInfos"]),
    layerInfo() {
      return this.layerInfos[this.layerId]
    },
    filteredLayerStepItems() {
      return this.layerStepItems.filter(item => item.temporalResolution === this.selectedTemporalResolution)
    },
    selectedCalenderStep: {
      get(){
        return this.selectedLayerStep.substring(0, 10)
      },
      set(date){
        this.selectedLayerStep = this.formatDate(date)
      }
    }
  },
  methods: {
    ...mapActions("map", ["toggle_layer", "change_layer", "set_layer_datetime", "set_temporal_resolution"]),
    formatDate(date) {
      if (!date) return null
      const [year, month, day] = date.split('-')
      let dateFormat = '';
      if (month !== undefined && day === undefined) {
        dateFormat = `${year}-${month}`
      } else if (month === undefined && day === undefined) {
        dateFormat = `${year}`
      } else {
        dateFormat = `${year}-${month}-${day}T00:00:00`
      }
      return dateFormat
    },
    formatDateSelect(entry) {
      let date = entry.datetime
      if (!date) return null
      date = date.replace('T00:00:00', '')
      const [year, month, day] = date.split('-')
      let dateFormat = '';
      if (month !== undefined && day === undefined) {
        dateFormat = `${year}-${month}`
      } else if (month === undefined && day === undefined) {
        dateFormat = `${year}`
      } else {
        dateFormat = `${year}-${month}-${day}`
      }
      return dateFormat
    },
    // For testing purposes
    async mockFetchLayerSteps() {
      await new Promise(resolve => setTimeout(resolve, 200));
      const result = {
        "data": [{
          "datetime": "2022-10-11T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-10-09T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-10-08T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-10-07T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-10-06T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-10-05T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-10-04T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-10-02T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-10-01T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-09-30T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }, {
          "datetime": "2022-09-29T00:00:00",
          "sensor": "SENT1",
          "resolution": 0.0089285714,
          "temporalResolution": "daily",
          "minzoom": 5,
          "maxzoom": 9,
          "bbox": [5, 47.008929, 16, 55.008929]
        }]
      }
      this.layerStepItems = result.data
      this.selectedLayerStep = result.data[0].datetime
      this.set_layer_datetime({datetime: this.selectedLayerStep, layerId: this.layerId})
      this.layerStepsLoading = false
    },
    async fetchLayerSteps() {
      let result = await ApiService.get(this.layerInfo.urlTimeLayers)
      this.layerStepItems = result.data
      this.selectedLayerStep = result.data[0].datetime
      this.set_layer_datetime({datetime: this.selectedLayerStep, layerId: this.layerId})
      this.set_temporal_resolution({temporalResolution: this.selectedTemporalResolution, layerId: this.layerId})
      this.layerStepsLoading = false
    },
    setCalendarDates() {
      this.maxCalendarDate = this.formatDateSelect(this.layerStepItems[0])
      this.minCalendarDate = this.formatDateSelect(this.layerStepItems[this.layerStepItems.length - 1])
    },
    selectOlderLayerStep() {
      const selectedLayerStepIndex = this.filteredLayerStepItems.findIndex(item => item.datetime === this.selectedLayerStep)
      const previousIndex = selectedLayerStepIndex + 1
      if (previousIndex < this.filteredLayerStepItems.length) {
        this.selectedLayerStep = this.filteredLayerStepItems[previousIndex].datetime
        this.changeMapLayer()
      }

    },
    selectNewerLayerStep() {
      const selectedLayerStepIndex = this.filteredLayerStepItems.findIndex(item => item.datetime === this.selectedLayerStep)
      const nextIndex = selectedLayerStepIndex - 1
      if (nextIndex >= 0) {
        this.selectedLayerStep = this.filteredLayerStepItems[nextIndex].datetime
        this.changeMapLayer()
      }
    },
    changeMapLayer() {
      this.set_layer_datetime({datetime: this.selectedLayerStep, layerId: this.layerId})
      this.set_temporal_resolution({temporalResolution: this.selectedTemporalResolution, layerId: this.layerId})
      if (this.layerInfo.active) {
        this.change_layer({datetime: this.selectedLayerStep, layerId: this.layerId})
      }
    },
    saveCalendarDate(){
      this.$refs.menu.save(this.selectedCalenderStep)
      this.changeMapLayer()
    },
    allowedCalendarDates (date) {
      let filter=this.formatDate(date)
      return !(this.layerStepItems.find(item => item.datetime === filter) === undefined);
    }
  },
  created() {
    this.fetchLayerSteps().then(() => {
      this.setCalendarDates()
    })
  }
}
</script>

<style scoped>

</style>